/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-eval */
import * as React from 'react';
import Grid from '@mui/material/Grid';
import ErrorIcon from '@mui/icons-material/Error';
import './noti.scss';
import { defaultModalOptions, defaultUnitValues } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { area_chart, CLROS3, CLROS4 } from '../../shared/assets/images';

const ClroRadioButtonsGroup = (props) => {
  const {
    totalHoldupVol, handleTotalHoldupVol, recovery, clroS1s2s3, captuROS1s2s3, updateS1S2S3Value, handleChangeRecovery,
    recoveryPerCircuit, handlerecoveryPerCircuit, translateObject, captu_ro, conc_recirc_flow
  } = props;
  const [modalOption, setModalOption] = React.useState(defaultModalOptions);
  const [ValidateImage, setValidateImage] = React.useState(false);
  const units = JSON.parse(localStorage.getItem('system-units')) || defaultUnitValues;
  const [tooltip, setTooltip] = React.useState(false);
  function getUnitValue(value) {
    if (value === 'Liquid Volume') {
      return units.volume || 'gal';
    }
    if (value === 'Flux') {
      return units.flux || 'gfd';
    }
  };
  const hoverPiping = (flag) => {
    setTooltip(flag);
  };
  const updateValue = (e, str) => {
    str = str.split('-')[1];
    updateS1S2S3Value(Number(e.target.value), str);
  };
  const blurInput = (e) => {
    let names = ['Clro-s1', 'Clro-s2', 'Clro-s3'];
    if (captu_ro) {
      names = ['CaptuRo-s0', 'CaptuRo-s1', 'CaptuRo-s2', 'CaptuRo-s3', 'CaptuRo-s4'];
    }
    const inputs = names.map(name => ({
      name,
      value: Number(document.querySelector(`[name="${name}"]`).value)
    }));
    const filledInputs = inputs.filter(input => input.value > 0);
    if ((!captu_ro && filledInputs.length === 2) || (captu_ro && filledInputs.length === 4)) {
      const emptyInput = inputs.find(input => input.value === 0);
      if (emptyInput) {
        const sum = filledInputs.reduce((acc, input) => acc + input.value, 0);
        const val = Math.max(0, (1 - sum).toFixed(2));
        const str = emptyInput.name.split('-')[1];
        updateS1S2S3Value(val, str);
        if (Number(e.target.value) === 0 || val < 0) {
          updateS1S2S3Value(0, str);
        }
      }
    }
  };
  return (
    <Grid item xs={12} container style={{ 'marginTop': '1%', position: 'relative' }}>
      <Grid item xs={6} md={6} sm={12} >
        <div className='mr-10' style={{ display: 'inline-flex', alignItems: 'center', position: 'relative' }}>
          <div className='field-text no_drag S_Bold'>{translateObject('Total holdup Volume')}</div>
          <input
            // hiddenLabel
            id="filled-hidden-label-small"
            variant="outlined"
            onChange={handleTotalHoldupVol}
            onFocus={e => e.target.select()}
            className="Form_Input_design combined-input-field no_drag"
            style={{ textAlign: 'center' }}
            type="number"
            name="TotalHoldupVol"
            value={totalHoldupVol}
          />
          <div className='Form_Input_design_Units field-unit-text fright no_drag' style={{ marginLeft: '5px' }}>{getUnitValue('Liquid Volume')}</div>
          <ErrorIcon className='no_drag' style={{ color: '#002d62', fontSize: 15 }} onMouseEnter={() => { hoverPiping(true); }} onMouseLeave={() => { hoverPiping(false); }} />
          {tooltip &&
            <div className='noti-wrapper-clro'>
              <span className='notification'>Hold up Volume is an optional input and will be calculated by Winflows if it is not provided here.
              </span>
            </div>
          }
        </div>
        <div className='' style={{ display: 'flex', alignItems: 'center', marginTop: 5 }}>
          {!captu_ro ? (
            ['s1', 's2', 's3'].map((ele, ind) => {
              return (
                <div key={ind} className='mr-10' style={{ display: 'flex', alignItems: 'center' }}>
                  <div className='field-text no_drag S_Bold'>{translateObject(ele.toUpperCase())}</div>
                  <input
                    onChange={(e) => { updateValue(e, `Clro-${ele}`); }}
                    onBlur={(e) => blurInput(e)}
                    onFocus={e => e.target.select()}
                    className="Form_Input_design combined-input-field no_drag"
                    style={{ textAlign: 'center' }}
                    type="number"
                    name={`Clro-${ele}`}
                    value={clroS1s2s3[ele]}
                    min='0'
                    max='1'
                  />
                </div>
              );
            })) : (
            ['s0', 's1', 's2', 's3', 's4'].map((ele, ind) => {
              return (
                <div key={ind} className='mr-10' style={{ display: 'flex', alignItems: 'center' }}>
                  <div className='field-text no_drag S_Bold'>{translateObject(ele.toUpperCase())}</div>
                  <input
                    onChange={(e) => { updateValue(e, `CaptuRo-${ele}`); }}
                    onBlur={(e) => blurInput(e)}
                    onFocus={e => e.target.select()}
                    className="Form_Input_design combined-input-field no_drag"
                    style={{ textAlign: 'center' }}
                    type="number"
                    name={`CaptuRo-${ele}`}
                    value={captuROS1s2s3[ele]}
                    min='0'
                    max='1'
                  />
                </div>
              );
            }))
          }
          <div>
            <img src={area_chart} className="no_drag" onMouseEnter={() => setValidateImage(true)} onMouseLeave={() => setValidateImage(false)} />
            {ValidateImage && (
              <img style={{ position: 'absolute', left: 0, top: '85%', zIndex: 99 }} src={!captu_ro ? CLROS3 : CLROS4} className="no_drag" onMouseEnter={() => setValidateImage(true)} onMouseLeave={() => setValidateImage(false)} />
            )}
          </div>
        </div>
      </Grid>
      <Grid item xs={6} md={6} sm={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', margin: '0 0 0 -10px' }}>
        <div className='mr-10' style={{ display: 'flex', alignItems: 'center' }}>
          <div className='field-text no_drag S_Bold'>{translateObject('RO Recovery')}</div>
          <input
            // hiddenLabel
            id="filled-hidden-label-small"
            variant="outlined"
            onChange={handleChangeRecovery}
            onFocus={e => e.target.select()}
            className="Form_Input_design combined-input-field no_drag"
            style={{ textAlign: 'center' }}
            type="number"
            name="recovery"
            value={recovery}
          />
          <div className='Form_Input_design_Units field-unit-text fright no_drag' style={{ marginLeft: '5px' }}>%</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className='field-text no_drag S_Bold'>{captu_ro ? translateObject('Conc Recirc flow') : translateObject('Array Recovery')}</div>
          {/* <div className='field-text no_drag S_Bold'>{translateObject('Array Recovery')}</div> */}
          <input
            // hiddenLabel
            id="filled-hidden-label-small"
            variant="outlined"
            onChange={handlerecoveryPerCircuit}
            onFocus={e => e.target.select()}
            className="Form_Input_design combined-input-field no_drag"
            style={{ textAlign: 'center' }}
            type="number"
            name="recoveryPerCircuit"
            value={captu_ro ? conc_recirc_flow : recoveryPerCircuit}
          />
          <div className='Form_Input_design_Units field-unit-text fright no_drag' style={{ marginLeft: '5px' }}>{captu_ro ? units.flow : '%'}</div>
          {/* <div className='Form_Input_design_Units field-unit-text fright no_drag' style={{ marginLeft: '5px' }}>%</div> */}
        </div>
      </Grid>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
    </Grid>
  );
};
export default ClroRadioButtonsGroup;